<!-- Header -->
<div class="flyout-header">
  <span class="material-icons flyout-header-icon">gavel</span>
  <h2 class="flyout-header-title">{{ jurisdictionDetails?.name || ('Jurisdiction' | translate) }}</h2>
</div>

<!-- Tabs -->
<div class="flyout-tabs">
  <button class="flyout-tab" [class.active]="activeTab === TABS.AGENTS" (click)="onTabChange(TABS.AGENTS)">
    <span class="material-icons" style="font-size:18px;">science</span>
    {{ 'Agents' | translate }}
  </button>
  <button class="flyout-tab" [class.active]="activeTab === TABS.RISK_CONFIG" (click)="onTabChange(TABS.RISK_CONFIG)">
    <span class="material-icons" style="font-size:18px;">shield</span>
    {{ 'Risk Configuration' | translate }}
  </button>
  <button class="flyout-tab" [class.active]="activeTab === TABS.BAYESIAN_CONFIG" (click)="onTabChange(TABS.BAYESIAN_CONFIG)">
    <span class="material-icons" style="font-size:18px;">insights</span>
    {{ 'Bayesian Configuration' | translate }}
  </button>
  <button class="flyout-tab" [class.active]="activeTab === TABS.ACCEPTANCE_RULES" (click)="onTabChange(TABS.ACCEPTANCE_RULES)">
    <span class="material-icons" style="font-size:18px;">rule</span>
    {{ 'Sample Acceptance Rules' | translate }}
  </button>
</div>

<!-- Agents Tab Content -->
@if (activeTab === TABS.AGENTS) {
  <div class="tab-content">
    <div class="jurisdiction-info-container">
      <div class="jurisdiction-info">
        <div class="info-field">
          <span class="info-label">{{ 'Apply Pressure Correction' | translate }}</span>
          <span class="info-value">{{ (jurisdictionDetails?.applyPressureCorrection ? 'Yes' : 'No') | translate }}</span>
        </div>
      </div>
      <div class="action-buttons">
        <button class="btn-add" *objectHasPermission="permissionObject; action: createAction" (click)="openAgentJurisdictionDialog()">
          <span class="material-icons">add</span> {{ 'Add' | translate }}
        </button>
      </div>
    </div>
    <div class="custom-theme-table">
      @if (dataSource) {
        <div class="custom-scrollbar table-responsive outer-bordered-table">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z1" matSort matSortDisableClear
            (matSortChange)="onSortChanged($event)">
            <tr class="mat-row" *matNoDataRow [ngClass]="{'loading-row':isLoading}">
              <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
                @if (isLoading) {
                  <ng-container class="loader-container">
                    <app-rings-loader class="bg-transparent"></app-rings-loader>
                  </ng-container>
                } @else {
                  {{ 'No data matching the filter' | translate }}
                }
              </td>
            </tr>
            <ng-container matColumnDef="masterAgentId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Agent Name' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.masterAgentName || '-' }}</td>
            </ng-container>
            <ng-container matColumnDef="al">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Action Level' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.al || '-' }}</td>
            </ng-container>
            <ng-container matColumnDef="oel">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'OEL' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.oelValue }}</td>
            </ng-container>
            <ng-container matColumnDef="oelTypeName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'OEL Type' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element?.oelTypeName || '-' }}</td>
            </ng-container>
            <ng-container matColumnDef="ceilingLimit">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Ceiling Limit' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.ceilingLimit || '-' }}</td>
            </ng-container>
            <ng-container matColumnDef="stel">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'STEL' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.stel || '-' }}</td>
            </ng-container>
            <ng-container matColumnDef="exchangeRate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Exchange Rate' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.exchangeRate || '-' }}</td>
            </ng-container>
            <ng-container matColumnDef="threshold">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Threshold' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.threshold || '-' }}</td>
            </ng-container>
            <ng-container matColumnDef="noiseFrequencyRating">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Noise Frequency Rating' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.noiseFrequencyRating != null ? noiseFrequencyRatingEnum[element.noiseFrequencyRating] : '-'}}</td>
            </ng-container>
            <ng-container matColumnDef="noiseSpeed">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Noise Speed' | translate }}</th>
              <td mat-cell *matCellDef="let element">{{ element.noiseSpeed || '-' }}</td>
            </ng-container>
            <ng-container matColumnDef="effectivePeriod">
              <th mat-header-cell *matHeaderCellDef>{{'Effective Period' | translate}}</th>
              <td mat-cell *matCellDef="let element">{{ element.effectivePeriodDisplay ?? '-' }}</td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>{{'Status' | translate}}</th>
              <td mat-cell *matCellDef="let element">
                <span class="version-status-badge" [ngClass]="element.statusClass">{{ element.statusLabel | translate }}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>{{'Actions' | translate}}</th>
              <td mat-cell *matCellDef="let element" class="text-align-right">
                @if (!element.isHistorical) {
                  <span class="material-icons edit cursor-pointer material-grey-icon"
                    *objectHasPermission="permissionObject; action: updateAction"
                    [matTooltip]="'Edit' | translate"
                  (click)="openAgentJurisdictionDialog(element.id)">edit</span>
                }
                @if (element.isHistorical) {
                  <span class="material-icons view cursor-pointer material-grey-icon"
                    [matTooltip]="'View' | translate"
                  (click)="openAgentJurisdictionDialog(element.id, true)">visibility</span>
                }
                @if (!element.isHistorical) {
                  <span class="material-icons add-version cursor-pointer material-grey-icon"
                    *objectHasPermission="permissionObject; action: createAction"
                    [matTooltip]="'New Version' | translate"
                  (click)="openNewVersionDialog(element.id)">library_add</span>
                }
                <span class="material-icons version-history cursor-pointer material-grey-icon"
                  [matTooltip]="'Version History' | translate"
                (click)="openVersionHistory(element.id)">history</span>
                @if (!element.isHistorical) {
                  <span class="material-icons delete cursor-pointer material-grey-icon"
                  *objectHasPermission="permissionObject; action: deleteAction"
                  (click)="openAgentJurisdictionDeleteDialog(element.id)">delete</span>
                }
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;" [class.even-row]="even" [class.historical-version-row]="row.isHistorical"> </tr>
          </table>
        </div>
      }
      <div class="paginator-container">
        <span>{{ 'Displaying' | translate }}</span>
        <mat-paginator [length]="dataSource.data.length" [pageSizeOptions]="[5, 10, 20]"
        [pageSize]="10"></mat-paginator>
      </div>
    </div>
  </div>
}

@if (activeTab === TABS.RISK_CONFIG) {
  <div class="tab-content">
    <app-jurisdiction-risk-config-form [jurisdictionId]="data"></app-jurisdiction-risk-config-form>
  </div>
}

@if (activeTab === TABS.BAYESIAN_CONFIG) {
  <div class="tab-content">
    <app-jurisdiction-risk-config-form [jurisdictionId]="data" [bayesianOnly]="true"></app-jurisdiction-risk-config-form>
  </div>
}

@if (activeTab === TABS.ACCEPTANCE_RULES) {
  <div class="tab-content">
    <app-sample-validation-rules-form></app-sample-validation-rules-form>
  </div>
}
